import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import './bootstrap.scss';
import './rsuite-custom-theme.scss';

import 'i18n';
import App from './App';
import { StylePage } from './pages/StylePage';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Clarity from '@microsoft/clarity';

// Initialize Clarity
switch (process.env.REACT_APP_ENV) {
  case 'prod':
    Clarity.init('u5b4i76j22');
    break;
  case 'uat':
    Clarity.init('tf68rpss5x');
    break;
  default:
    break;
}

const routing = (
  <BrowserRouter>
    <Switch>
      <Route path='/styles' component={StylePage} />
      <Route path='/' component={App} />
    </Switch>
  </BrowserRouter>
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(routing);
